module.exports = __webpack_public_path__ + "media/assets/icons/mail-unread-bd3650682ba4aaea04ca5579b0c1e4ff.svg";